









































import { mapMutations, mapGetters } from 'vuex'
import { Component, Vue } from 'vue-property-decorator'

@Component({
  name: 'MyToolBar'
  //   metaInfo() {
  //     return {
  //       title: 'Vuetify Admin Dashboard'
  //     }
  //   }
})
export default class extends Vue {
  color = 'light-blue darken-2'
  get title() {
    return this.$store.state.title
  }
  private responsive = false
  private responsiveInput = false

  get activeNotifications() {
    return this.$store.state.notifications.filter(not => {
      return not.active
    }).length
  }
  private switchTheme() {
    this.$vuetify.theme.dark = !this.$vuetify.theme.dark
    localStorage.setItem('darkMode', this.$vuetify.theme.dark.toString())
  }
  private onClick() {
    // ...
  }
  private logout() {
    this.$store.dispatch('logout')
  }
}

//   computed: {
//     ...mapGetters(['authorized'])
//   },

//   watch: {
//     $route (val) {
//       this.title = val.meta.name
//     }
//   },

//   mounted () {
//     this.onResponsiveInverted()
//     window.addEventListener('resize', this.onResponsiveInverted)
//   },
//   beforeDestroy () {
//     window.removeEventListener('resize', this.onResponsiveInverted)
//   },

//   methods: {
//     ...mapMutations('app', ['setDrawer', 'toggleDrawer']),
//     onClickBtn () {
//       this.setDrawer(!this.$store.state.app.drawer)
//     },
//     onClick () {
//       //
//     },
//     onResponsiveInverted () {
//       if (window.innerWidth < 991) {
//         this.responsive = true
//         this.responsiveInput = false
//       } else {
//         this.responsive = false
//         this.responsiveInput = true
//       }
//     },
//     logout: function () {
//       this.$store.dispatch('logout').then(() => {
//         this.$router.push('/')
//       })
//     }
//   }
// }
